import React from 'react'

import Section from '../Section'

import phoneIcon from 'assets/images/contacts/Editor/editor-phone-20.svg'
import { useTranslation } from 'react-i18next'

interface PhonesProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Phones = ({ editData, onFieldChange, onLabelChange, onAddItem, onDelete }: PhonesProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="phones"
      labelList={[
        { key: 'mobile', label: t('contact.property.mobile') },
        { key: 'work', label: t('contact.property.work') },
        { key: 'home', label: t('contact.property.home') },
        { key: 'fax', label: t('contact.property.fax') },
        { key: 'pager', label: t('contact.property.pager') },
        { key: 'other', label: t('contact.property.other') },
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]}
      icon={phoneIcon}
      addButtonLabel={t('contact.menu.addPhone')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(index) => index !== 0}
    />
  )
}
export default Phones
